import Select from "react-select"
import pluralize from 'pluralize'
import React, { useState, useEffect, useRef } from 'react'
import { Link, Switch, Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Dropdown, Select as AntSelect, Menu, Popover, Badge, message } from 'antd'
import axios from 'axios'

import { FaHandHolding } from 'react-icons/fa'
import { BiSelectMultiple } from 'react-icons/bi'
import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { addItemToAccQueue, clearAccQueue, removeAccItem } from '../../store/actions'
import { useToggle, useListData, usePet, useSocketEvents, server } from '../../modules'

import Receive from '../../components/reusable/receive'
import Confirm from '../../components/reusable/confirm'
import Modal from '../../components/reusable/modal'

import Returns from '../../components/modals/returns'
import Batches from '../../components/modals/batches'
import SelfIssue from '../../components/modals/selfIssue'
import RestockItem from '../../components/modals/restockitem'
import RestockOpen from '../../components/modals/restockOpen'
import DispenseItems from '../../components/modals/dispenseItems'
import RecordSpoilage from '../../components/modals/recordspoilage'
import ModifyQuantity from '../../components/modals/modifyquantity'

import Movement from '../../components/drawers/movement'
import ItemHistory from '../../components/drawers/itemHistory'
import StoreRequests from '../../components/drawers/storeRequests'
import EditInventoryItem from '../../components/drawers/editInventoryItem'
import RequestsHistory from "../../components/drawers/requestsHistory"

const { Option } = AntSelect

const Inventory = ({ store }) => {
    const { user } = useSelector(state => state.application)
    const { queue } = useSelector(state => state.accounting)

    const dispatch = useDispatch()

    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState({ label: 'All', value: 'All' })
    const [requests, setRequests] = useState(0)

    const [restockModal, toggleRestockModal] = useToggle()
    const [modifyQuantityModal, toggleModifyQuantityModal] = useToggle()
    const [inventoryItemModal, toggleInventoryItemModal] = useToggle()
    const [spoilageModal, toggleSpoilageModal] = useToggle()
    const [dispenseModal, toggleDispenseModal] = useToggle()
    const [invEdit, toggleInvEdit] = useToggle()
    const [request, toggleRequest] = useToggle()
    const [requestsDrawer, toggleRequestsDrawer] = useToggle()
    const [self, toggleSelf] = useToggle()
    const [selectMode, toggleSelectMode] = useToggle(queue.length > 0)
    const [batches, toggleBatches] = useToggle()
    const [returnsModal, toggleReturnsModal] = useToggle()
    const [bulkImportModal, toggleBulkImportModal] = useToggle()
    const [bulkFile, setBulkFile] = useState(null)
    const [bulkLoading, setBulkLoading] = useState(false)
    const [bulkResult, setBulkResult] = useState(null)
    const bulkFileInputRef = useRef(null)

    usePet('inventoryCategories', null, { notify: true, callback: ({ data }) => setCategories(data) })

    const [, getSaleItem] = usePet('saleItemByInvItem', { id: selected?._id }, { notify: true, callback: ({ data }) => dispatch(addItemToAccQueue(selected.item, data.price)), manual: true })

    const [, getRequests] = usePet('requestsByStore', { store: store?.value, type: "Received", classif: 'Pending' }, { notify: true, manual: true, callback: ({ data }) => setRequests(data.count) })

    const restock = itm => {
        setSelected(itm)
        toggleRestockModal()
    }

    const spoilage = itm => {
        setSelected(itm)
        toggleSpoilageModal()
    }

    const returns = itm => {
        setSelected(itm)
        toggleReturnsModal()        
    }

    const modifyQty = itm => {
        setSelected(itm)
        toggleModifyQuantityModal()
    }

    const edit = itm => {
        setSelected(itm)
        toggleInvEdit()
    }

    const issueToSelf = rec => {
        setSelected(rec)
        toggleSelf()
    }

    const viewRequests = rec => {
        setSelected(rec)
        toggleRequestsDrawer()
    }

    const viewBatches = rec => {
        setSelected(rec)
        toggleBatches()
    }

    const chooseItem = itm => {
        let i = queue.findIndex(e => e.item._id === itm.item._id)
        if (i >= 0) {
            dispatch(removeAccItem(i))
        } else {
            setSelected(itm)
            getSaleItem()
        }
    }

    const [
        { loading: invLoading, error: invError, fetch }, 
        { list: inventory = [] }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('inventory', {
        store: store?.value,
        category: category?.value !== 'All' ? category?.value : undefined,
        string
    }, { notify: true, manual: true })

    const refresh = () => {
        fetch()
        getRequests()
        navigate(1)
    }

    useSocketEvents({
        'new-request': {
            condition: data => data.store === store?.name,
            notif: {
                message: 'New Request',
                type: 'info'
            },
            callback: getRequests
        }
    })

    const search = str => {
        setString(str)
        if (str?.trim().length > 1 || str.length === 0)
            refresh()
    }

    const selectCategory = val => {
        setCategory(val)
        refresh()
    }

    const [{ loading }, toggleDelete] = usePet('toggleDeleteItem', {
        id: selected?.item?._id
    }, { notify: true, callback: ({}, notif, ops) => {
        notif('Item has been deleted', ops('success'))      
        refresh()  
    }, manual: true, load: { msg: selected?.item?.deleted ? 'Undoing delete action...' : 'Deleting this item...' } })

    const deleteItem = itm => {
        setSelected(itm)
        toggleDelete()
        // toggleDeleteModal()
    }

    useEffect(() => {
        refresh()

        return () => null
    }, [store])

    const openBulkImport = () => {
        setBulkFile(null)
        setBulkResult(null)
        if (bulkFileInputRef.current)
            bulkFileInputRef.current.value = ''
        toggleBulkImportModal()
    }

    const submitBulkImport = async () => {
        if (!store?.value) {
            message.warning('Please select a store')
            return
        }
        if (!bulkFile) {
            message.warning('Choose a CSV or Excel file first')
            return
        }
        const token = sessionStorage.getItem('token')
        const form = new FormData()
        form.append('store', store.value)
        form.append('file', bulkFile)
        form.append('hasFile', true)
        form.append('timeStamp', new Date().toISOString())
        setBulkLoading(true)
        setBulkResult(null)
        try {
            const res = await axios.post(`${server}/api/bulkImportInventoryItems`, form, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
            })
            const body = res.data
            if (body.error) {
                message.error(body.message || 'Import failed')
                return
            }
            const { createdCount, errors = [] } = body.data || {}
            setBulkResult(body.data)
            message.success(`Imported ${createdCount ?? 0} item(s).`)
            if (errors.length)
                message.warning(`${errors.length} row(s) could not be imported — see details below.`)
            refresh()
        } catch (err) {
            const msg = err.response?.data?.message || err.message || 'Import failed'
            message.error(msg)
        } finally {
            setBulkLoading(false)
        }
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <ModifyQuantity
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleModifyQuantityModal}
                visible={modifyQuantityModal} />
            <RestockOpen
                store={store}
                onPerform={fetch}
                toggle={toggleInventoryItemModal}
                visible={inventoryItemModal} />
            <RestockItem
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleRestockModal}
                visible={restockModal} />
            <Returns
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleReturnsModal}
                visible={returnsModal} />
            {/* <DeleteItem
                onPerform={fetch}
                record={ selected }
                toggle={toggleDeleteModal}
                visible={deleteModal} /> */}
            <RecordSpoilage
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleSpoilageModal}
                visible={spoilageModal} />
            <DispenseItems
                store={store}
                onPerform={fetch}
                toggle={toggleDispenseModal }
                visible={ dispenseModal } />
            {
                invEdit &&
                <EditInventoryItem
                    store={ store }
                    onPerform={fetch}
                    visible={ invEdit }
                    item={ selected?.item }
                    toggle={toggleInvEdit } />
            }
            {
                batches &&
                <Batches
                    rec={ selected }
                    toggle={toggleBatches }
                    visible={ batches } />
            }
            <SelfIssue
                store={store}
                onPerform={fetch}
                record={ selected }
                toggle={toggleSelf}
                visible={self} />
            <Modal
                w={ 520 }
                title="Bulk import inventory"
                toggle={toggleBulkImportModal}
                visible={bulkImportModal}>
                <p className="text-sm text-gray-600 mb-3">
                    Upload a CSV or Excel file. Required columns: <strong>name</strong>, <strong>category</strong>, <strong>issuedIn</strong>, <strong>sellingPrice</strong>.
                    Optional: receivedIn (defaults to issuedIn), purchaseAccount (default &quot;Inventory Asset&quot;), initialQuantity (default 0),
                    reorderLevel (default 10), salesAccount (default &quot;Medication&quot;).
                </p>
                <p className="text-xs text-gray-500 mb-3">
                    Header row may use spaces or camelCase, e.g. <code className="bg-gray-100 px-1 rounded">selling price</code> or <code className="bg-gray-100 px-1 rounded">sellingPrice</code>.
                </p>
                <input
                    ref={bulkFileInputRef}
                    type="file"
                    accept=".csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    className="block w-full text-sm text-gray-600 mb-4"
                    onChange={e => {
                        setBulkFile(e.target.files?.[0] ?? null)
                        setBulkResult(null)
                    }} />
                {
                    bulkResult?.errors?.length > 0 &&
                    <div className="max-h-40 overflow-y-auto mb-4 text-sm border border-amber-200 bg-amber-50 rounded p-2">
                        <p className="font-semibold text-amber-900 mb-1">Rows not imported</p>
                        <ul className="list-disc pl-4 text-amber-900 space-y-0.5">
                            {
                                bulkResult.errors.map((e, i) =>
                                    <li key={i}>Row {e.row}: {e.message}</li>)
                            }
                        </ul>
                    </div>
                }
                <div className="flex justify-end gap-2">
                    <button type="button" onClick={toggleBulkImportModal} className="btn border border-gray-300 text-gray-700 px-4 py-2 rounded-lg text-sm">
                        Close
                    </button>
                    <button
                        type="button"
                        disabled={bulkLoading}
                        onClick={submitBulkImport}
                        className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5">
                        { bulkLoading ? 'Importing…' : 'Import' }
                    </button>
                </div>
            </Modal>
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="grid grid-flow-col sm:auto-cols-max items-center justify-center sm:justify-end gap-2">
                    <input
                        onChange={ e => search(e.target.value) }
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Type to search items" />
                    {/* <Select
                        value={ store }
                        onChange={ selectStore }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={ stores }
                        placeholder="Select Store" /> */}
                    {
                        (user?.issuperuser || user.stations?.some(st => st.name === 'store' && (st.permissions.includes('edit-items') || st.permissions.includes('*')))) &&
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item key="add" onClick={() => toggleInventoryItemModal()}>
                                        Add item
                                    </Menu.Item>
                                    <Menu.Item key="bulk" onClick={openBulkImport}>
                                        Bulk add from CSV / Excel
                                    </Menu.Item>
                                </Menu>
                            }>
                            <button type="button" className="btn hisani-btn-green-light text-white">
                                <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                                <span className="hidden xs:block ml-2">Add</span>
                                <AiOutlineDown className="ml-1 opacity-80" />
                            </button>
                        </Dropdown>
                    }
                    {
                        (store?.permissions?.includes('*') || store?.permissions?.includes('handle-requests') || user?.issuperuser) &&
                        <Badge count={ requests }>
                            <Link to={ `/app/store/inventory/requests/${store?.value}` }>
                                <button className="btn flex items-center hisani-btn-green-light text-white">
                                    <FaHandHolding />
                                    <span className="hidden xs:block ml-2">Requests</span>
                                </button>
                            </Link>
                        </Badge>
                    }
                    {
                        queue.length > 0 ?
                        <Dropdown
                            overlay={
                                <Menu>
                                    <Menu.Item onClick={ () => {
                                        dispatch(clearAccQueue())
                                        toggleSelectMode()
                                     } }>Deselect All</Menu.Item>
                                    <Menu.Item onClick={ toggleRequest }>Request Items</Menu.Item>
                                </Menu>
                            }>
                            <button className="btn hisani-btn-green-light text-white">
                                <span className="hidden xs:block mr-2">Actions ({ queue.length })</span>
                                <AiOutlineDown />
                            </button>
                        </Dropdown>
                        :
                        <button onClick={ () => toggleSelectMode() } className="btn hisani-btn-green-light text-white">
                            <BiSelectMultiple style={{ color: "white" }} />
                            <span className="hidden xs:block ml-2">{ selectMode ? 'Deselect' : 'Select' }</span>
                        </button>
                    }
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Inventory</h2>
                    <span className="flex items-center justify-between">
                        <Select
                            value={category}
                            onChange={selectCategory}
                            className="mr-2"
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ [{ label: 'All', value: 'All' }, ...categories.map(cat => ({ label: cat, value: cat }))] }
                            placeholder="Select Category" />
                        <button onClick={ refresh } className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    {
                        store ?
                            <div className="overflow-x-auto">
                                <Receive
                                    error={invError}
                                    loading={invLoading}
                                    progress>
                                    {
                                        inventory?.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">No</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Item</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Category</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Quantity</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center"></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        inventory.map((rec, key) =>
                                                            <tr>
                                                                <td className="p-2">
                                                                    <div className="text-center">
                                                                        {
                                                                            selectMode ?
                                                                                <input
                                                                                    onChange={() => chooseItem(rec)}
                                                                                    checked={ queue.some(e => e.item._id === rec.item._id) }
                                                                                    type="checkbox"
                                                                                    className="form-checkbox cursor-pointer h-5 w-5" />
                                                                            :
                                                                                `${((page - 1) * limit) + key + 1}.`
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{rec.item.name}</div>
                                                                    {
                                                                        rec?.item?.code &&
                                                                        <p className="text-gray-500 text-xs italic">{rec?.item?.code}</p>
                                                                    }
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{rec.item.category}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{rec.variations.reduce((total, variant) => total + variant.total, 0)} {rec.item.issuedIn}</div>
                                                                </td>
                                                                <td className="p-2 text-center">
                                                                    <Dropdown
                                                                        overlay={() => {
                                                                            let override = store?.permissions?.includes('*') || user?.issuperuser

                                                                            return (
                                                                                <Menu>
                                                                                    {
                                                                                        (user.stations?.some(st => st.name === 'store' && (st.permissions.includes('edit-items') || st.permissions.includes('*'))) && override) &&
                                                                                        <Menu.Item onClick={ () => edit(rec) }>View</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (user.stations?.some(st => st.name === 'store' && (st.permissions.includes('view-available-batches') || st.permissions.includes('*'))) && override) &&
                                                                                        <Menu.Item onClick={ () => viewBatches(rec) }>View Batches</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                         (store?.permissions?.includes('view-request-history') || override) &&
                                                                                        <Menu.Item><Link className="text-gray-600 hover:text-gray-600" to={ `/app/store/inventory/requests-history/${rec?.item?._id }/${store?.value}` }>View Request History</Link></Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('restock-items') || override) &&
                                                                                        <Menu.Item onClick={ () => restock(rec) }>Restock Item</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('move-stock') || override) &&
                                                                                        <Menu.Item onClick={ () => restock(rec) }>Move to Another Store</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('modify-quantity') || override) &&
                                                                                        <Menu.Item onClick={ () => modifyQty(rec)}>Modify Quantity</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('view-history') || override) &&
                                                                                        <Menu.Item><Link className="text-gray-600 hover:text-gray-600" to={ `/app/store/inventory/history/${rec?.item?._id }/${store?.value}` }>View History</Link></Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('view-movement') || override) &&
                                                                                        <Menu.Item><Link className="text-gray-600 hover:text-gray-600" to={ `/app/store/inventory/movement/${rec?.item?._id }/${store?.value}` }>View Movement</Link></Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('record-returns') || override) &&
                                                                                        <Menu.Item onClick={ () => returns(rec) }>Record Returns</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('record-spoilage-damage') || override) &&
                                                                                        <Menu.Item onClick={ () => spoilage(rec) }>Record Spoilage/Damage</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (store?.permissions?.includes('issue-to-self') || override) &&
                                                                                        <Menu.Item onClick={ () => issueToSelf(rec) }>Issue to Self</Menu.Item>
                                                                                    }
                                                                                    {
                                                                                        (user.stations?.some(st => st.name === 'store' && (st.permissions.includes('delete-items') || st.permissions.includes('*'))) && override) &&
                                                                                        <Menu.Item onClick={ () => {
                                                                                            let qty = rec.variations.reduce((total, variant) => total + variant.total, 0)

                                                                                            Confirm({
                                                                                                title: 'Delete This Item',
                                                                                                message: qty > 0 ? `There are ${qty} ${pluralize(rec?.item?.issuedIn, qty)} of this item, please ensure that they have been moved to a different record before deleting` : 'Please confirm before performing this action',
                                                                                                okText: 'Delete Item',
                                                                                                onOk: () => deleteItem(rec)
                                                                                            })
                                                                                            } }>{ rec?.item?.deleted ? 'Undelete' : 'Delete' }</Menu.Item>
                                                                                    }
                                                                                </Menu>

                                                                            )
                                                                        }}>
                                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="w-full h-16 flex items-center justify-center">
                                                <p className="font-semibold text-base">No items were found</p>
                                            </div>
                                    }
                                </Receive>
                                { Paginate }
                            </div>
                        :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please select a store</p>
                            </div>
                    }
                </div>
            </div>
            <Switch>
                <Route path="/app/store/inventory/requests/:id">
                    <StoreRequests path="/app/store/inventory" onPerform={() => null} />
                </Route>
                <Route path="/app/store/inventory/requests-history/:id/:store">
                    <RequestsHistory path="/app/store" onClose={ refresh } />
                </Route>
                <Route path="/app/store/inventory/history/:id/:store">
                    <ItemHistory path="/app/store" onClose={ refresh } />
                </Route>
                <Route path="/app/store/inventory/movement/:id/:store">
                    <Movement path="/app/store" onClose={ refresh } />
                </Route>
            </Switch>
        </div>
    )
}

export default Inventory